import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContentListStateService {
  private contentListHasChanged = new BehaviorSubject<boolean>(false);
  contentListChangeState = this.contentListHasChanged.asObservable();
  constructor() {}

  changeContentList(hasContentListChanged: boolean) {
    this.contentListHasChanged.next(hasContentListChanged);
  }
  isContentListChanged(): boolean {
    return this.contentListHasChanged.getValue();
  }
}
